import { SlidersHorizontal } from "lucide-react";
import { Button } from "../ui/button";

export type FilterChip = {
  label: string;
  active?: boolean;
  /** Stable identity for onSelect consumers — selection must not key on the display label. */
  value?: string;
};

type FilterChipGroupProps = {
  filters: FilterChip[];
  disabled?: boolean;
  onSelect?: (filter: FilterChip) => void;
  showMoreFilters?: boolean;
};

export function FilterChipGroup({
  filters,
  disabled = false,
  onSelect,
  showMoreFilters = true,
}: FilterChipGroupProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {filters.map((filter) => (
        <Button
          key={filter.value ?? filter.label}
          type="button"
          variant={filter.active ? "secondary" : "outline"}
          size="sm"
          shape="pill"
          disabled={disabled}
          onClick={onSelect ? () => onSelect(filter) : undefined}
          aria-pressed={onSelect ? !!filter.active : undefined}
          className={onSelect ? "cursor-pointer" : undefined}
        >
          {filter.label}
        </Button>
      ))}
      {showMoreFilters && (
        <Button type="button" variant="ghost" size="icon" disabled={disabled} aria-label="More filters">
          <SlidersHorizontal className="size-4" />
        </Button>
      )}
    </div>
  );
}
